module.exports = __webpack_public_path__ + "img/decoration-logo.442c6f7b.png";